define('ShippingRestrictions.Helper', [
  'underscore',
  'Utils'
], function (
  _,
  Utils
) {
  'use strict';

  var STATE_FIELDS = [
    { field: 'custitem_walthers_item_az', state: 'AZ' },
    { field: 'custitem_walthers_item_ca', state: 'CA' },
    { field: 'custitem_walthers_item_nv', state: 'NV' },
    { field: 'custitem_walthers_item_tx', state: 'TX' }
  ];

  var NORTH_AMERICA_COUNTRIES = ['US', 'CA', 'MX'];

  function isFlagged(item, fieldName) {
    var value;

    if (!item || typeof item.get !== 'function') {
      return false;
    }

    value = item.get(fieldName);

    return value === true || value === 'T';
  }

  function getItemLabel(item) {
    if (!item || typeof item.get !== 'function') {
      return '';
    }

    return item.get('_name') || item.get('itemid') || '';
  }

  function withItemInfo(item, violation) {
    return _.extend({
      item: item,
      itemId: item.get('internalid'),
      itemLabel: getItemLabel(item)
    }, violation);
  }

  function checkAddressRestrictions(item, address) {
    var violations = [];
    var state = address && address.state;
    var country = address && address.country;

    if (!country) {
      return violations;
    }

    _.each(STATE_FIELDS, function (entry) {
      if (isFlagged(item, entry.field) && state === entry.state) {
        violations.push({
          reasonCode: 'STATE_' + entry.state,
          reasonMessage: Utils.translate('$(0) cannot be shipped to $(1).', getItemLabel(item), entry.state)
        });
      }
    });

    if (isFlagged(item, 'custitem_walthers_item_us_only') && country !== 'US') {
      violations.push({
        reasonCode: 'US_ONLY',
        reasonMessage: Utils.translate('$(0) can only be shipped within the US.', getItemLabel(item))
      });
    }

    if (isFlagged(item, 'custitem_walthers_item_canada') && country === 'CA') {
      violations.push({
        reasonCode: 'CANADA',
        reasonMessage: Utils.translate('$(0) cannot be shipped to Canada.', getItemLabel(item))
      });
    }

    if (isFlagged(item, 'custitem_walthers_item_na_only') && !_.contains(NORTH_AMERICA_COUNTRIES, country)) {
      violations.push({
        reasonCode: 'NA_ONLY',
        reasonMessage: Utils.translate('$(0) can only be shipped within North America (US, Canada, Mexico).', getItemLabel(item))
      });
    }

    return violations;
  }

  function checkAirRestriction(item, shipMethodId, airShipMethodIds) {
    var isAirRestricted = isFlagged(item, 'custitem_walthers_item_air') || isFlagged(item, 'custitem_hazmat_item_web');

    if (!isAirRestricted || !shipMethodId || !airShipMethodIds || !airShipMethodIds.length) {
      return null;
    }

    if (!_.contains(airShipMethodIds, String(shipMethodId))) {
      return null;
    }

    return {
      reasonCode: 'AIR',
      reasonMessage: Utils.translate('$(0) cannot be shipped through our standard shipping method due to shipping restrictions. Please remove this item to continue, or contact us for assistance.', getItemLabel(item))
    };
  }

  return {

    parseAirShipMethodIds: function parseAirShipMethodIds(rawConfigValue) {
      if (!rawConfigValue) {
        return [];
      }

      return _.chain(String(rawConfigValue).split(','))
        .map(function (id) {
          return id.trim();
        })
        .compact()
        .value();
    },

    evaluate: function evaluate(options) {
      var lines = (options && options.lines) || [];
      var address = options && options.address;
      var shipMethodId = options && options.shipMethodId;
      var airShipMethodIds = (options && options.airShipMethodIds) || [];
      var violations = [];

      var addLineViolations = function addLineViolations(line) {
        var item = typeof line.get === 'function' ? line.get('item') : null;
        var airViolation;

        if (!item) {
          return;
        }

        _.each(checkAddressRestrictions(item, address), function (violation) {
          violations.push(withItemInfo(item, violation));
        });

        airViolation = checkAirRestriction(item, shipMethodId, airShipMethodIds);

        if (airViolation) {
          violations.push(withItemInfo(item, airViolation));
        }
      };

      if (typeof lines.each === 'function') {
        lines.each(addLineViolations);
      } else {
        _.each(lines, addLineViolations);
      }

      return violations;
    },

    buildErrorMessage: function buildErrorMessage(violations) {
      return _.map(violations, function (violation) {
        return violation.reasonMessage;
      }).join('<br><br>');
    }
  };
});
